import lazySizes from 'lazysizes';

lazySizes.cfg.loadHidden = false;
lazySizes.cfg.expFactor = 1;
lazySizes.cfg.loadMode = 1;

lazySizes.init();

export {};
